// Tipos de documento del filtro de Pedidos. Las claves son las del scope
// `Order.with_document_type`, que junta el vocabulario de Bsale (tipo del DTE) con el de
// Relbase ('invoice', 'delivery-note'): "Factura" trae las dos. Son tambien las claves
// que una compañia puede dejar como "solo superadmin" (`Order::DOCUMENT_TYPE_KEYS`).
export const DOCUMENT_TYPES = [
    { key: 'boleta',         label: 'Boleta E.' },
    { key: 'factura',        label: 'Factura' },
    { key: 'factura_exenta', label: 'Factura exenta' },
    { key: 'nota_venta',     label: 'N. Venta' },
    { key: 'guia_despacho',  label: 'Guía de despacho' },
    { key: 'nota_credito',   label: 'Nota de crédito' },
    { key: 'nota_debito',    label: 'Nota de débito' },
    { key: 'traslado',       label: 'Traslado' },
    { key: 'otro',           label: 'Otro' },
    // El pedido creado a mano en Haulers mientras no tenga documento.
    { key: 'manual',         label: 'Manual' },
    { key: 'sin_documento',  label: 'Sin documento' },
];

export const DOCUMENT_TYPE_KEYS = DOCUMENT_TYPES.map((t) => t.key);

// Formas de envio que el mismo filtro "Tipo de pedido" ofrece junto a los documentos. Van por
// `q[with_shipping_kind]` (`Order::SHIPPING_KIND_SQL`): no son documentos, asi que no se
// pueden dejar como "solo superadmin".
export const SHIPPING_KINDS = [
    { key: 'flex',   label: 'Flex' },
    { key: 'full',   label: 'Full' },
    { key: 'retiro', label: 'Retiro en tienda' },
];

export const SHIPPING_KIND_KEYS = SHIPPING_KINDS.map((t) => t.key);
